import React, { useMemo, useState } from 'react';
import Link from 'next/link';
import {
  PAYMENTS_ITEM_ID,
  SERVICE_ITEM_ID,
  PROMO_ITEM_ID,
} from '~/src/components/Header';
import * as ST from './styled';
import PopupNoWork from '~/src/components/Popups/NoWorkExcuses/popupExcuses';

interface Item {
  id: number;
  name: string;
  link: string;
}
interface IProps {
  item: Item;
  isFixed?: boolean;
  isCollapsedMenu?: boolean;
  typeMenu?: string;
  itemRef?: (instance: HTMLDivElement | null) => void;
  onClick: (item: string, menuType?: string) => void;
  onHover: (item: string, menuType?: string) => void;
  clickHandler?: () => void;
}

export const MenuItem = ({
  item,
  onClick,
  onHover,
  itemRef,
  typeMenu = 'Main menu',
}: IProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => {
    setIsOpen(!isOpen);
  };
  const isTarriffItem = useMemo(() => {
    if (
      item.id !== PAYMENTS_ITEM_ID &&
      item.id !== SERVICE_ITEM_ID &&
      item.id !== PROMO_ITEM_ID
    ) {
      return true;
    }
  }, [item.id]);

  return item.id === 3 ? (
      <ST.MenuItem
      ref={itemRef}
      key={item.id}
      withButton={isTarriffItem}
      data-test='menu-item'
  ><a onClick={handleClose} style={{ cursor: 'pointer' }}>{item.name}</a>
    <PopupNoWork isOpen={isOpen} onClose={handleClose}/>
  </ST.MenuItem>) : (
    <ST.MenuItem
      ref={itemRef}
      key={item.id}
      withButton={isTarriffItem}
      data-test='menu-item'
    >
      <Link href={item.link} prefetch={false}>
        <a
          onClick={() => onClick(item.name, typeMenu)}
          onMouseEnter={() => onHover(item.name, typeMenu)}
        >
          {item.name}
        </a>
      </Link>
    </ST.MenuItem>
  );
};
